//import sistema from "./sistema/siqa"
import funciones from './funcion/siqa'
import catalogos from "./catalogos/siqa"


const siqa = {
  funciones: funciones,
  catalogos: catalogos,
  //sistema: sistema
}

export default siqa;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIQA/siqaapi.js
// module id = null
// module chunks = 